import {
  USQCPPage,
  UKQCPPage,
  ReferralPage,
  AgentReferralPage,
  QuestionnairePage,
  PersonalisedCoverPage,
  ShowcasePage,
  PostQuoteQuestionnairePage,
  RecommendationsPage,
  ExplanationPage,
} from "@simplybusiness/mobius-journey";
import DevTools from "../packs/components/DevTools";
import Autofill from "../packs/components/Autofill";
import SkipToQcp from "../packs/components/SkipToQcp";
import ViewTraces from "../packs/components/ViewTraces";

export const pageComponents = {
  ReferralPage,
  USQCPPage,
  UKQCPPage,
  AgentReferralPage,
  QuestionnairePage,
  PersonalisedCoverPage,
  PostQuoteQuestionnairePage,
  ShowcasePage,
  RecommendationsPage,
  ExplanationPage,
} ;

export const utilityComponents = {
  DevTools,
  Autofill,
  SkipToQcp,
  ViewTraces,
} ;
